import { Card } from "react-bootstrap";

export default function StatCard({
    title,
    value,
    color,
    icon: Icon,
}) {
    return (
        <Card
            className="h-100 border-0"
            style={{
                background: color,
                borderRadius: 14,
                boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
            }}
        >
            <Card.Body
                className="position-relative text-white"
                style={{ padding: "16px 18px" }}
            >
                {/* ICON BACKGROUND */}
                {Icon && (
                    <Icon
                        size={48}
                        style={{
                            position: "absolute",
                            right: 12,
                            top: 12,
                            opacity: 0.18,
                        }}
                    />
                )}

                {/* CONTENT */}
                <div>
                    <small
                        className="d-block mb-1"
                        style={{
                            fontSize: 12,
                            opacity: 0.9,
                            letterSpacing: 0.3,
                        }}
                    >
                        {title}
                    </small>

                    {value !== undefined && (
                        <h3
                            className="fw-bold mb-0"
                            style={{
                                lineHeight: 1.1,
                                color: "rgba(255,255,255,0.9)",
                            }}
                        >
                            {value.toLocaleString("id-ID")}
                        </h3>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
}
